/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {STOREFRONT_URLS} from '@amblique/base/app/constants/storefront-urls';

export const urlHelper = {
  /**
   * @private
   */
  _seoUrlRegex: null,

  /**
   * @private
   */
  _pipelineUrlRegex: null,

  /**
   * @private
   */
  _pipelinesToPaths: {},

  /**
   * @returns {RegExp}
   */
  get seoUrlRegex() {
    if (!this._seoUrlRegex) {
      this._seoUrlRegex = new RegExp(`^.*/(${Object.keys(STOREFRONT_URLS).join('|')})(?:/|$)(.*?)(?:\\.html.*|\\?.*|\\/.*)?$`);
    }

    return this._seoUrlRegex;
  },

  /**
   * @returns {RegExp}
   */
  get pipelineUrlRegex() {
    if (!this._pipelineUrlRegex) {
      const pipelines = new Set();
      const identifiers = new Set();

      for (const [path, {pipeline, identifier, params}] of Object.entries(STOREFRONT_URLS)) {
        pipeline && pipelines.add(pipeline);
        identifier && identifiers.add(identifier);

        if (pipeline) {
          this._pipelinesToPaths[pipeline + (identifier ? ':identifier' : '')] = {mappedPath: path, params};
        }
      }

      this._pipelineUrlRegex = new RegExp(`^.*\\/(${[...pipelines].join('|')})\\/?(?:\\?(?:${[...identifiers].join('|')})=(.*?)(?:&|$))?(.*)$`);
    }

    return this._pipelineUrlRegex;
  },

  /**
   * Parse SFRA storefront URLs to PWA route paths.
   *
   * @param {string} url
   *
   * @returns {{
   *  path: string,
   *  identifier: string|null,
   *  searchParams: string,
   *  appUrl: string|null
   * }}
   */
  parseStorefrontUrl(url) {
    const [, path, identifier = null, searchParams = ''] = url.match(this.seoUrlRegex) || url.match(this.pipelineUrlRegex) || [];
    let appUrl = null;

    if (path !== undefined) {
      const {mappedPath, params} = this._pipelinesToPaths[path + (identifier ? ':identifier' : '')] || STOREFRONT_URLS[path] || {};

      appUrl = '/' + [mappedPath || path, identifier].filter(Boolean).join('/');

      if (searchParams && Array.isArray(params)) {
        const urlSearchParams = new URLSearchParams(searchParams);

        for (const key of urlSearchParams.keys()) {
          if (!params.includes(key)) {
            urlSearchParams.delete(key);
          }
        }

        appUrl += urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : '';
      }
    }

    return {path, identifier, searchParams, appUrl};
  },
};
